<template>
  <section class="terms-and-conditions">
    <h2 class="title">{{ data.title }}</h2>
    <div class="terms-area">
      <div class="term" v-for="(term, index) of data.terms_area" :key="`term-${index}`">
        <h3 class="term-title">{{ term.title }}</h3>
        <div class="term-content" v-html="term.description" />
        <template v-if="term.link_file">
          <Button
            v-if="term.file.download_text"
            color="dark-green"
            lineHover="bg-mint-30"
            circleColor="circle-orange"
            target="_blank"
            :download="term.title"
            :url="term.file.document.url"
            :text="term.file.download_text"
          />
        </template>
        <template v-else>
          <Button
          v-if="term.link.download_text"
          color="dark-green"
          lineHover="bg-mint-30"
          circleColor="circle-orange"
          :url="term.link.url"
          :text="term.link.title"
        />
        </template>
      </div>
    </div>
  </section>
</template>
<script setup>
import Button from '@/components/utility/Button.vue'
defineProps(['data'])
</script>
<style lang="scss" scoped>
  .terms-and-conditions {
    @apply main-container lg:px-28;
    .title {
      @apply pl-0 lg:pl-12 text-ore_green_dark text-3xl font-light leading-[30px] font-FHOscar;
    }
    .terms-area {
      @apply mt-20 flex flex-wrap gap-x-40 gap-y-10;
      .term:deep() {
        @apply w-full lg:w-[35%] mb-20;
        .term-title {
          @apply text-ore_green_dark text-[40px] font-light leading-10 font-FHOscar mb-8;
        }
        .term-content {
          @apply mb-12;
          p {
            @apply mb-6;
          }
        }
      }
    }
  }
</style>
